import { render, staticRenderFns } from "./portfoliotypologiesc.vue?vue&type=template&id=4365b94e&scoped=true&"
import script from "./portfoliotypologiesc.vue?vue&type=script&lang=js&"
export * from "./portfoliotypologiesc.vue?vue&type=script&lang=js&"
import style0 from "./portfoliotypologiesc.vue?vue&type=style&index=0&id=4365b94e&lang=scss&scoped=true&"
import style1 from "./portfoliotypologiesc.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365b94e",
  null
  
)

export default component.exports